/**
 * Placeholder legal pages.
 *
 * The wording here is a structural skeleton, not reviewed legal text — replace
 * the body with copy from your own counsel before launch. The routes and links
 * exist now so the rest of the site is not broken by their absence.
 */

import { Alert } from '../components/ui'

const TERMS: [string, string][] = [
  [
    '1. Предмет',
    'QR24 надає доступ до вебсервісу та API для формування QR-кодів платежів за стандартом Національного банку України. Сервіс не є платіжною системою, не приймає, не зберігає й не переказує кошти користувачів.',
  ],
  [
    '2. Обліковий запис',
    'Користувач відповідає за збереження API-ключів. Усі запити, здійснені з дійсним ключем, вважаються здійсненими користувачем. У разі компрометації ключа його слід негайно відкликати в кабінеті.',
  ],
  [
    '3. Тарифікація',
    'Одиницею тарифікації є один згенерований QR-код. Валідація та розбір не тарифікуються. Оплачений період не підлягає поверненню, окрім випадків, передбачених законодавством України.',
  ],
  [
    '4. Обмеження',
    'Забороняється перепродаж доступу до API без письмової згоди, автоматизоване створення облікових записів та дії, що створюють надмірне навантаження на інфраструктуру.',
  ],
  [
    '5. Відповідальність',
    'Сервіс надається «як є». Користувач самостійно перевіряє правильність реквізитів платежу перед публікацією QR-коду. QR24 не несе відповідальності за помилки в наданих користувачем даних.',
  ],
  [
    '6. Зміни умов',
    'Про суттєві зміни умов ми повідомляємо електронною поштою щонайменше за 14 днів до набрання ними чинності.',
  ],
]

const PRIVACY: [string, string][] = [
  [
    '1. Які дані ми обробляємо',
    'Email, імʼя, назва компанії, податковий код (за бажанням), IP-адреса, метадані запитів до API (час, ендпоінт, статус, затримка).',
  ],
  [
    '2. Реквізити платежів',
    'Реквізити, передані в запитах на генерацію, обробляються в оперативній памʼяті та не зберігаються, окрім випадків, коли ви явно передали save: true. Збережені записи можна видалити в кабінеті.',
  ],
  [
    '3. Паролі та ключі',
    'Паролі зберігаються у вигляді Argon2-хешів. Секретні частини API-ключів зберігаються як HMAC-SHA256 і не можуть бути відновлені.',
  ],
  [
    '4. Передача третім сторонам',
    'Дані не передаються третім сторонам, окрім платіжного провайдера (для обробки оплат) і хостинг-провайдера інфраструктури.',
  ],
  [
    '5. Строки зберігання',
    'Журнали запитів зберігаються 12 місяців, платіжні документи — відповідно до вимог законодавства. Після видалення акаунта дані видаляються протягом 30 днів.',
  ],
  [
    '6. Ваші права',
    'Ви маєте право на доступ, виправлення, видалення та перенесення своїх даних. Звернення надсилайте на api@qr24.app.',
  ],
]

export function Legal({ kind }: { kind: 'terms' | 'privacy' }) {
  const isTerms = kind === 'terms'
  const sections = isTerms ? TERMS : PRIVACY

  return (
    <div className="container-page max-w-3xl py-12">
      <h1 className="text-3xl font-bold tracking-tight">
        {isTerms ? 'Умови використання' : 'Політика конфіденційності'}
      </h1>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
        Редакція від {new Date().toLocaleDateString('uk-UA')}
      </p>

      <Alert tone="warning" title="Шаблонний текст">
        Це структурна заготовка, а не перевірений юридичний документ. Замініть її текстом
        від свого юриста до запуску.
      </Alert>

      <div className="mt-8 space-y-8">
        {sections.map(([title, body]) => (
          <section key={title}>
            <h2 className="text-lg font-semibold">{title}</h2>
            <p className="mt-2 leading-relaxed text-slate-600 dark:text-slate-300">{body}</p>
          </section>
        ))}
      </div>
    </div>
  )
}
